import React from "react";
import { Modal, Button, Row } from "react-bootstrap";
import HiddenMetricsList from "./HiddenMetricsList";

const OutcomesSettingsModal = (props) => {
  const handleClose = () => {
    props.closeModal();
  };

  return (
    <Modal show={props.show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Outcomes Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label>Select the outcomes you would like to hide.</label>
        <HiddenMetricsList />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="info" onClick={() => handleClose()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OutcomesSettingsModal;
